import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import {
    PatientDot,
    ThumbsUpButton,
    ThumbsDownButton,
    EditNoteButton,
    PatientCareCenterButton,
    PdfButton,
    ExcelButton,
    LoadingIcon,
    SaveButton,
    CancelButton
} from '_components'
import { NotesRequiringApprovalTabs } from 'MessageCenter/NotesRequiringApproval'
import { notesReqApprovalActions, patientActions } from '_actions';
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import { CSSTransition } from 'react-transition-group'
import './Details.css'
import styles from './Details.module.css'
import { pdfService } from '_services';
import { alService } from '_services';

class NotesRequiringApprovalDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rejectReason: ""
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({ rejectReason: event.target.value });
    }

    openPdf(noteId) {
        let newWindow = window.open('/loading.html');
        newWindow.onload = () => {
            pdfService.raw(noteId)
                .then(response => response.blob())
                .then(blobby => {
                    let objectUrl = window.URL.createObjectURL(blobby);
                    newWindow.location = objectUrl;
                });
        }
    }

    openAl(noteId) {
        let anchor = document.createElement("a");
        document.body.appendChild(anchor);

        alService.raw(this.props.message.epno)
            .then(response => response.blob())
            .then(blobby => {
                let objectUrl = window.URL.createObjectURL(blobby);
                anchor.href = objectUrl;
                anchor.click();

                window.URL.revokeObjectURL(objectUrl);

            });
    }

    editNote() {
        this.props.editNote(this.props.message.ptno, this.props.message.id, this.props.message.epno);
    }


    render() {
        var options = { year: '2-digit', month: 'numeric', day: 'numeric' };
        let pteroNoteTypes = [1, 2, 3, 4, 5, 6];

        if (this.props.message)
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Notes Requiring Approval: {this.props.message.ptname + " - " + (this.props.noteType ? this.props.noteType.MTABBREV : "") + " " + new Date(this.props.message.noteDate).toLocaleDateString("en-US", options)}</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />

                    <div className={styles.details_table}>
                        <div className={styles.details_cell} >
                            <div className={styles.labels}>
                                <div>Patient:</div>
                                <div>Author:</div>
                                {this.props.message.ciName !== '' &&
                                    <div>Clinic Instr:</div>
                                }
                                <div>Admission:</div>
                                <div>Payer Name:</div>
                                <div>DOS:</div>
                                <div>Type:</div>
                            </div>
                            <div className={styles.data}>
                                <div style={this.props.message.isFederal === true ? { fontStyle: 'italic' } : {}}><span style={{ display: 'inline-block' }}><PatientDot id={this.props.message.dot} /></span>{' ' + this.props.message.ptname + ' (SYS#' + this.props.message.ptno + ')'}</div>
                                <div>{this.props.message.therapistName}</div>
                                {this.props.message.ciName !== '' &&
                                    <div>{this.props.message.ciName}</div>
                                }
                                <div>{this.props.message.admissionDesc + ' - ' + this.props.message.discipline + ' - ' + this.props.message.locationName}</div>
                                <div>{this.props.message.payercontract}</div>
                                <div>{new Date(this.props.message.noteDate).toLocaleDateString("en-US", options) + ' (visit ' + this.props.message.visitNum + ')'}</div>
                                <div>{(this.props.noteType ? this.props.noteType.MTABBREV : "")}</div>
                            </div>
                        </div>
                        <div className={styles.button_wrapper}>
                            <div className={styles.button_div}>
                                <span className={styles.button}><ThumbsUpButton title='Approve Note' onClick={() => this.props.approveMsg(this.props.message.id)} /></span>
                                <span className={styles.button}><ThumbsDownButton title='Reject Note' onClick={() => this.props.toggleReject()} /></span>
                                {pteroNoteTypes.includes(this.props.message.noteType) &&
                                    <span className={styles.button}><EditNoteButton onClick={() => this.editNote()} /></span>
                                }
                                <span className={styles.button}><PatientCareCenterButton ptno={this.props.message.ptno} /></span>
                                <span className={styles.button}><PdfButton onClick={() => this.openPdf(this.props.message.id)} /></span>
                                <ExcelButton onClick={() => this.openAl(this.props.message.id)} />
                            </div>
                        </div>
                    </div>

                    <div>
                        <CSSTransition
                            key={this.props.message.id}
                            in={this.props.rejectVisible}
                            timeout={400}
                            classNames='rejectslidedown'
                            unmountOnExit
                        >
                            <div>
                                <div style={{ paddingLeft: '20px' }}><b>Reason for Rejection</b></div>
                                <div style={{ display: 'table', width: '100%', paddingBottom: '10px', paddingLeft: '20px' }}>
                                    <div style={{ display: 'table-cell', lineHeight: '20px', verticalAlign: 'top', paddingRight: '5px' }}>
                                        <textarea autoFocus name="rejectReason" type="text" className={styles.reject} rows="4" value={this.state.rejectReason} onChange={this.handleChange} />
                                    </div>
                                    <div style={{ display: 'table-cell', width: '80px', verticalAlign: 'bottom' }}>
                                        <div style={{ display: 'inline-block' }}>
                                            <span style={{ paddingRight: '5px' }}><SaveButton onClick={() => this.props.rejectMsg(this.props.message.id, this.state.rejectReason)} /></span>
                                            <span style={{ paddingRight: '5px' }}><CancelButton onClick={() => this.props.toggleReject()} /></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CSSTransition>
                    </div>

                    <NotesRequiringApprovalTabs />

                </div>
            );
        else
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Notes Requiring Approval</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />
                    {this.props.loading === true ?
                        <LoadingIcon size="small" />
                        : <div style={{ fontStyle: 'italic' }}>No Message Selected</div>
                    }
                </div>
            );
    }
}

function mapStateToProps(state) {
    return {
        message: state.entities.notesReqApproval[state.ui.notesReqApproval.selectedMessage],
        noteType: state.ui.notesReqApproval.selectedMessage &&
            state.entities.notesReqApproval[state.ui.notesReqApproval.selectedMessage].noteType ?
            state.entities.masterData.PTMASTERNOTETYPES[state.entities.notesReqApproval[state.ui.notesReqApproval.selectedMessage].noteType] :
            undefined,
        loading: state.ui.notesReqApproval.loading,
        rejectVisible: state.ui.notesReqApproval.rejectVisible
    };
}


function mapDispatchToProps(dispatch) {
    return {
        approveMsg: bindActionCreators(notesReqApprovalActions.approve, dispatch),
        rejectMsg: bindActionCreators(notesReqApprovalActions.reject, dispatch),
        toggleReject: bindActionCreators(notesReqApprovalActions.toggleReject, dispatch),
        editNote: bindActionCreators(patientActions.openEditNote, dispatch)
    };
}

const connectedNotesRequiringApprovalDetails = connect(mapStateToProps, mapDispatchToProps)(NotesRequiringApprovalDetails);
export { connectedNotesRequiringApprovalDetails as NotesRequiringApprovalDetails };
